/** Framework filter labels — passed as-is to `framework` query param (matches API `framework` field). */
export const COMPLIANCE_FRAMEWORK_FILTER_OPTIONS = [
  'CIS Controls',
  'PCI DSS',
  'NIST',
  'HIPAA',
  'GDPR',
  'ISO 27001',
  'Internal Policy',
].map((label) => ({ label, value: label }));

/** Category filter labels — passed as-is to `category` query param (matches API `category` field). */
export const COMPLIANCE_CATEGORY_FILTER_OPTIONS = [
  'Network Security',
  'Identity',
  'Data Protection',
  'Patch Management',
  'Device Control',
  'Monitoring',
  'Compliance',
  'General',
].map((label) => ({ label, value: label }));
